import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const VisibleCountryCode = iotsUtils.fromList(constants.country.visibleCountryCodes);
